import { ThunkDispatch } from "core-integration/src/store";
import { IPickLight } from "core-integration/src/store/entries/types";
import { actionSubstitution } from "core-integration/src/store/my-team/thunks";
import * as React from "react";
import { connect } from "react-redux";
import Pitch, { PitchRow, PitchUnit } from "../Pitch";
import TeamPitchElement from "./TeamPitchElement";

interface IFormationProps {
  generateProps: (i: number) => {
    actionMe: () => void;
    chipName: string | null;
    pick: IPickLight;
    renderDreamTeam: (pick: IPickLight) => React.ReactNode;
    renderElementMenu: () => void;
    renderPickValue: (pick: IPickLight) => React.ReactNode;
    eventId?: number;
  };
}

const FiveFourOne: React.FC<IFormationProps> = ({ generateProps }) => (
  <>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(0)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(1)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(2)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(3)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(4)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(5)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(6)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(7)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(8)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(9)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(10)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
  </>
);

const FiveThreeTwo: React.FC<IFormationProps> = ({ generateProps }) => (
  <>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(0)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(1)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(2)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(3)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(4)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(5)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(6)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(7)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(8)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(9)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(10)} />
      </PitchUnit>
      <PitchUnit />
    </PitchRow>
  </>
);

const FiveTwoThree: React.FC<IFormationProps> = ({ generateProps }) => (
  <>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(0)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(1)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(2)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(3)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(4)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(5)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(6)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(7)} />
      </PitchUnit>
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(8)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(9)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(10)} />
      </PitchUnit>
    </PitchRow>
  </>
);

const FourFiveOne: React.FC<IFormationProps> = ({ generateProps }) => (
  <>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(0)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(1)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(2)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(3)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(4)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(5)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(6)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(7)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(8)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(9)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(10)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
  </>
);

const FourThreeThree: React.FC<IFormationProps> = ({ generateProps }) => (
  <>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(0)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(1)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(2)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(3)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(4)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(5)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(6)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(7)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(8)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(9)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(10)} />
      </PitchUnit>
    </PitchRow>
  </>
);

const FourFourTwo: React.FC<IFormationProps> = ({ generateProps }) => (
  <>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(0)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(1)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(2)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(3)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(4)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(5)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(6)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(7)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(8)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(9)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(10)} />
      </PitchUnit>
      <PitchUnit />
    </PitchRow>
  </>
);

const ThreeFourThree: React.FC<IFormationProps> = ({ generateProps }) => (
  <>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(0)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(1)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(2)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(3)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(4)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(5)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(6)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(7)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(8)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(9)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(10)} />
      </PitchUnit>
    </PitchRow>
  </>
);

const ThreeFiveTwo: React.FC<IFormationProps> = ({ generateProps }) => (
  <>
    <PitchRow>
      <PitchUnit />
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(0)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit />
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(1)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(2)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(3)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit>
        <TeamPitchElement {...generateProps(4)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(5)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(6)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(7)} />
      </PitchUnit>
      <PitchUnit>
        <TeamPitchElement {...generateProps(8)} />
      </PitchUnit>
    </PitchRow>
    <PitchRow>
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(9)} />
      </PitchUnit>
      <PitchUnit />
      <PitchUnit>
        <TeamPitchElement {...generateProps(10)} />
      </PitchUnit>
      <PitchUnit />
    </PitchRow>
  </>
);

interface IPropsFromDispatch {
  substitute: (elementId: number) => void;
}

interface IProps {
  chipName: string | null;
  formation: string;
  picks: IPickLight[];
  renderDreamTeam: (pick: IPickLight) => React.ReactNode;
  renderElementMenu: (element: number) => void;
  renderPickValue: (pick: IPickLight) => React.ReactNode;
  eventId?: number;
}

type Props = IPropsFromDispatch & IProps;

interface IFormations {
  [key: string]: React.ReactNode;
}

const PitchFormation: React.FC<Props> = ({
  chipName,
  formation,
  substitute,
  picks,
  renderDreamTeam,
  renderElementMenu,
  renderPickValue,
  eventId,
}) => {
  const sharedTeamPitchElementProps = (i: number) => ({
    actionMe: () => substitute(picks[i].element),
    chipName,
    pick: picks[i],
    renderDreamTeam,
    renderElementMenu: () => renderElementMenu(picks[i].element),
    renderPickValue,
    eventId,
  });
  const formations: IFormations = {
    "1-5-4-1": <FiveFourOne generateProps={sharedTeamPitchElementProps} />,
    "1-5-3-2": <FiveThreeTwo generateProps={sharedTeamPitchElementProps} />,
    "1-5-2-3": <FiveTwoThree generateProps={sharedTeamPitchElementProps} />,
    "1-4-5-1": <FourFiveOne generateProps={sharedTeamPitchElementProps} />,
    "1-4-4-2": <FourFourTwo generateProps={sharedTeamPitchElementProps} />,
    "1-4-3-3": <FourThreeThree generateProps={sharedTeamPitchElementProps} />,
    "1-3-5-2": <ThreeFiveTwo generateProps={sharedTeamPitchElementProps} />,
    "1-3-4-3": <ThreeFourThree generateProps={sharedTeamPitchElementProps} />,
  };
  return <Pitch>{formations[formation]}</Pitch>;
};

const mapDispatchToProps = (dispatch: ThunkDispatch): IPropsFromDispatch => ({
  substitute: (elementId) => dispatch(actionSubstitution(elementId)),
});

export default connect(null, mapDispatchToProps)(PitchFormation);
